var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"m3 7 6 6 4-4 8 8","key":0}),React.createElement("path",{"d":"M21 10v7h-7","key":1})]));
}

ArrowDown.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
